module.exports = __webpack_public_path__ + "media/aerial-farm-fullhd02.f3fc6227.mp4";